// /signup-kine/email-enviado y /signup-paciente/email-enviado —
// pantalla de confirmación post-signUp. Comparten copy + estructura,
// son una sola página renderizada en dos rutas.
//
// El email de confirmación lo manda Supabase Auth automáticamente
// (con redirect a /login configurado en signUp). Esta pantalla solo
// informa al usuario que revise su email.
//
// El email viene en route state desde el form de signup. Si llega
// directo sin state (deep-link, refresh), mostramos copy genérico
// sin nombre.

import { Link, useLocation } from "react-router";
import { Mail } from "lucide-react";
import { AuthLayout } from "@/app/components/auth/AuthLayout";
import { Button } from "@/app/components/ui/button";

export function SignupEmailEnviado() {
  const location = useLocation();
  const state = location.state as { email?: string } | null;
  const email = state?.email;

  return (
    <AuthLayout
      title="Revisá tu email"
      subtitle={
        email
          ? `Te enviamos un email a ${email} para confirmar tu cuenta.`
          : "Te enviamos un email para confirmar tu cuenta."
      }
    >
      <div className="flex items-center justify-center py-4">
        <Mail className="w-12 h-12 text-primary" strokeWidth={1.5} />
      </div>
      <p className="text-sm text-muted-foreground text-center mb-2">
        Una vez confirmado, podés iniciar sesión.
      </p>
      <p className="text-xs text-muted-foreground text-center mb-6">
        Si no lo ves en unos minutos, revisá spam.
      </p>
      <Link to="/login" className="block">
        <Button type="button" className="w-full">
          Ir a iniciar sesión
        </Button>
      </Link>
    </AuthLayout>
  );
}
